// extracted by mini-css-extract-plugin
export var block_image = "imageTextBlock-module--block_image--2x77K";
export var header = "imageTextBlock-module--header--oKcmN";
export var image_text_block_container = "imageTextBlock-module--image_text_block_container--qvaYN";
export var image_text_block_container_small = "imageTextBlock-module--image_text_block_container_small--ANRIv";
export var text_content = "imageTextBlock-module--text_content--aQj96";